import { ResponseDataTest } from "../../../models/responseDataTest";
import { agroApi } from "../api";
import { ResponseDataGet } from "../../../models/responseDataGet";
import { EntDirectoryInfoName } from "../../../models/directoryInfoName";
import { EntInitialFilterName } from "../../../models/filters/initialFilterName";
import { Paths } from "../../../paths";

export const transportStatusApi = agroApi.injectEndpoints({
    endpoints: (builder) => ({
        getTransportStatusList: builder.query<ResponseDataGet<EntDirectoryInfoName>, EntInitialFilterName>({
            query: (filter) => ({
                url: `${Paths.handbooks.transportstatus}/get-all`,
                method: "POST",
                body: JSON.stringify(filter)
            }),
        }),
        getTransportStatusById: builder.query<ResponseDataTest<EntDirectoryInfoName>, number>({
            query: (id) => ({
                url: `${Paths.handbooks.transportstatus}/${id}`,
                method: 'GET'
            })
        }),
        addTransportStatus: builder.mutation<ResponseDataTest<EntDirectoryInfoName>, EntDirectoryInfoName>({
            query: (body) => ({
                url: `${Paths.handbooks.transportstatus}`,
                method: "POST",
                body: JSON.stringify(body)
            }),
        }),
        editTransportStatus: builder.mutation<ResponseDataTest<EntDirectoryInfoName>, EntDirectoryInfoName>({
            query: (body, ) => ({
                url: `${Paths.handbooks.transportstatus}`,
                method: 'PUT',
                body: JSON.stringify(body),
            }),
        }),
        deleteTransportStatus: builder.mutation<ResponseDataTest<EntDirectoryInfoName>, number>({
            query: (id) => ({
                url: `${Paths.handbooks.transportstatus}/${id}`,
                method: 'DELETE',
            }),
        }),
    }),
    overrideExisting: false,
});

export const {
    useAddTransportStatusMutation,
    useDeleteTransportStatusMutation,
    useEditTransportStatusMutation,
    useLazyGetTransportStatusListQuery
} = transportStatusApi;
